import {ServiceKindLight, ServiceKindTypeEnum} from '@store/settings/serviceKinds';
import {SelectItem} from '@components/inputs/select/Select.component';
import {OrganisationLight} from '@store/common/organisation.model';
import I18n from '@utils/i18n.utils';

export interface ManageIndexation {
  id?: number;
  name?: string;
  invoiceName?: string;
  code?: string;
  serviceKind?: ServiceKindLight;
  serviceKindId?: number;
  indexationRates?: IndexationRate[];
  currentIndexationRate?: IndexationRate;
  serviceKindItem?: SelectItem;
  initialRate?: number;
  initialDate?: Date;
  clientOrganisationIds?: number[];
  supplierOrganisationIds?: number[];
  serviceKindTypes?: ServiceKindTypeEnum[];
  type?: IndexationType;
}

export namespace Indexation {
  export const toManageIndexation = (indexation: Indexation): ManageIndexation => ({
    ...indexation,
    serviceKindId: indexation.serviceKind.id,
    serviceKindItem: {
      label: indexation.serviceKind.kind,
      value: indexation.serviceKind.id,
    }
  });
}

export enum IndexationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum IndexationType {
  BUY = 'BUY',
  SELL = 'SELL',
}

export namespace IndexationType {
  export const selectItems = (): SelectItem[] => [
    {label: I18n.t('global.indexationType.buy'), value: IndexationType.BUY},
    {label: I18n.t('global.indexationType.sell'), value: IndexationType.SELL},
  ];
}

export interface IndexationRate {
  id: number;
  fromDate: Date;
  rateInPercent: number;
}

export interface ManageIndexationRate {
  fromDate?: Date;
  rateInPercent?: number;
}


export interface Indexation {
  id: number;
  name: string;
  invoiceName: string;
  code: string;
  serviceKind: ServiceKindLight;
  indexationRates?: IndexationRate[];
  currentIndexationRate?: IndexationRate;
  clientOrganisations?: OrganisationLight[];
  supplierOrganisations?: OrganisationLight[];
  serviceKindTypes?: ServiceKindTypeEnum[];
  type?: IndexationType;
}
